






































import Vue from 'vue';
import { isEmpty } from 'lodash';
import { BButton } from 'bootstrap-vue';
import RecurrenceInfo from '../../recurrence/RecurrenceInfo.vue';
import { RecurrenceTypes } from '../../recurrence/utils';

export default Vue.extend({
  name: 'RecurrenceWrapper',
  components: {
    BButton,
    RecurrenceInfo,
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
    },
    scheduleTitle: {
      type: String,
      default: '',
    },
    initialConfig: {
      type: Object,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    recApiUrl: {
      type: String,
      required: true,
    },
    scheduleData: {
      type: Array,
      default() {
        return [];
      },
    },
    updatedRecurrenceFlag: {
      type: Boolean,
      required: true,
    },
    objectTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    containerClass(): { [key: string]: boolean } {
      return { 'text-above': this.hasSchedule };
    },
    hasSchedule(): boolean {
      return !isEmpty(this.initialConfig);
    },
    recurrenceType() {
      if (!this.scheduleData) return RecurrenceTypes.Legacy;

      const recType = this.scheduleData.find(field => field.name === 'recurrenceType');
      if (recType) {
        return recType.value;
      }

      return RecurrenceTypes.Legacy;
    },
    showLegacyMessage() {
      // show legacy recurrence message as we were showing them (even if the ff is on)
      return this.recurrenceType === RecurrenceTypes.Legacy && this.hasSchedule;
    },
  },
  methods: {
    open() {
      let type = 'RecurrenceModal';
      const data = {
        type: this.type,
        initialConfig: this.initialConfig,
        csrfToken: this.csrfToken,
        recApiUrl: this.recApiUrl,
      };

      window.GGRC.zenModal.show({
        type,
        data,
        config: { ignoreUrl: true },
      });
    },
    openConfirmStop() {
      let type = 'StopRecurrenceModal';
      const data = {
        type: this.type,
        csrfToken: this.csrfToken,
        recApiUrl: this.recApiUrl,
      };

      if (this.updatedRecurrenceFlag) {
        type = 'NewStopRecurrenceModal';
        data.objectTitle = this.objectTitle;
      }

      window.GGRC.zenModal.show({
        type,
        data,
        config: { ignoreUrl: true },
      });
    },
  },
});
